import React from "react";
import styled from "styled-components";
import { colors } from "core/stylesheet";
import { keys } from "ramda";
import { Icon } from "components/generic/kit";

const TagWrap = styled.div`
  background-color: ${colors.brand};
  font-family: CircularStd-Book;
  color: white;
`;
export default ({ selected, onRemove, onClearAll }) => (
  <div className="flex items-center mt4-ns flex-wrap f7 pt4-ns">
    {keys(selected).reduce(
      (acc, field) => [
        ...acc,
        ...selected[field].map((value, i) => (
          <TagWrap
            className=" br2 ba pa2 mr2 mb2 flex items-center"
            key={field + "_" + value}
          >
            {value}
            <Icon
              onClick={() => onRemove({ field, value })}
              className="ml2 pointer"
              size=".85"
            >
              close
            </Icon>
          </TagWrap>
        ))
      ],
      []
    )}
    {!!selected.length && (
      <div className="underline pointer mb2" onClick={onClearAll}>
        Clear all
      </div>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/InsidersList/internal/SelectedFilters.js